import React, { useRef, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import DefaultModal from 'components/Modal/DefaultModal';
import AccountsListTable from './AccountsListTable';

const GraphicAccountsWithDateByResponsible = ({ accountsCountBySeller }) => {
  const chartRef = useRef();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalAccounts, setModalAccounts] = useState([]);

  const getGraphicResponsibleLabels = () => {
    if (!accountsCountBySeller) return [];
    return accountsCountBySeller.map(
      (item) => item.responsibleName || 'Sem responsável'
    );
  };

  const activeColor = '#2ecc40';
  const inactiveColor = '#ff4136';

  const dataSets = () => {
    if (!accountsCountBySeller) return [];
    return [
      {
        label: 'Ativas',
        backgroundColor: activeColor,
        stack: 'Status',
        data: accountsCountBySeller.map((item) => Number(item.activeCount))
      },
      {
        label: 'Inativas',
        backgroundColor: inactiveColor,
        stack: 'Status',
        data: accountsCountBySeller.map((item) => Number(item.inactiveCount))
      }
    ];
  };

  const handleBarClick = (event) => {
    if (!chartRef.current) return;
    const chartInstance = chartRef.current.chartInstance;
    const element = chartInstance.getElementAtEvent(event)[0];
    if (!element) return;
    const datasetIndex = element._datasetIndex;
    const index = element._index;
    const responsible = accountsCountBySeller[index];
    if (!responsible) return;
    let accounts = [];
    let title = '';
    if (datasetIndex === 0) {
      accounts = responsible.activeAccounts || [];
      title = `Contas Ativas - ${
        responsible.responsibleName || 'Sem responsável'
      }`;
    } else if (datasetIndex === 1) {
      accounts = responsible.inactiveAccounts || [];
      title = `Contas Inativas - ${
        responsible.responsibleName || 'Sem responsável'
      }`;
    }
    setModalAccounts(accounts);
    setModalTitle(title);
    setIsModalOpen(true);
  };

  return (
    <>
      <div className="chart mt-5">
        <Bar
          ref={chartRef}
          data={{
            labels: getGraphicResponsibleLabels(),
            datasets: dataSets()
          }}
          options={{
            showLines: true,
            onClick: handleBarClick,
            scales: {
              yAxes: [
                {
                  gridLines: {
                    color: '#e9ecef',
                    zeroLineColor: '#e9ecef'
                  },
                  ticks: {
                    callback: function (value) {
                      if (!(value % 10)) {
                        return value;
                      }
                    }
                  }
                }
              ],
              xAxes: [
                {
                  maxBarThickness: 100
                }
              ]
            },
            tooltips: {
              callbacks: {
                label: function (item, data) {
                  var label = data.datasets[item.datasetIndex].label || '';
                  var yLabel = item.yLabel;
                  var content = '';
                  if (data.datasets.length > 1) {
                    content += ` ${label}`;
                  }
                  content += ` ${yLabel}`;
                  return content;
                }
              }
            }
          }}
          className="chart-canvas"
          id="chart-bars"
        />
      </div>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={setIsModalOpen}
        title={modalTitle}
        showCloseButton={false}
        modalContainerClasses=""
      >
        <AccountsListTable accounts={modalAccounts} title={modalTitle} />
      </DefaultModal>
    </>
  );
};

export default GraphicAccountsWithDateByResponsible;
